import React, { PureComponent, Fragment } from 'react'
import { ToastContainer } from 'react-toastify'
import { func } from 'prop-types'
import SearchContent from './SearchContent'
import AddressBar from './AddressBar'
import Sidebar from './Sidebar'
import Footer from './Footer'
import EdgeSwipe from './EdgeSwipe'
import DeviceEvents from './DeviceEvents'
import CloseSearchContent from './SearchContent/CloseSearchContent'
import DOTlogo from './DOTlogo'
import History from '../History'
import withAnalytics from '../Analytics'
import StreetViewMap from './StreetViewMap'

class ElementsGroup extends PureComponent {
  render() {
    return (
      <Fragment>
        <History />
        <DeviceEvents />
        <EdgeSwipe registerEvent={this.props.registerEvent} />
        <AddressBar registerEvent={this.props.registerEvent} />
        <Sidebar />
        <SearchContent />
        <CloseSearchContent />
        <ToastContainer className="main-alert" autoClose={3000} />
        <Footer />
        <DOTlogo className="dot_logo main" />
        <StreetViewMap />
      </Fragment>
    )
  }
}

ElementsGroup.propTypes = {
  registerEvent: func.isRequired,
}

export default withAnalytics(ElementsGroup)



// WEBPACK FOOTER //
// ./src/components/Elements/index.jsx